import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Dialog } from '@material-ui/core';
import { Assignment, Call, Note } from '@material-ui/icons';
import IconButtonLabelBelow from 'Components/UI/IconButtonLabelBelow';
import modalConsts from 'Consts/ModalNames';
import closeModal, { openModal } from '../../../Helpers/ModalHelper';

const styles = theme => ({
  paper: {
    padding: theme.spacing(3),
    width: '100%',
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  icon: {
    color: theme.palette.facet.accentBlue,
  },
});

const changeModals = modal => () => {
  closeModal();
  openModal(modal);
};

const TimelineNewEventDialog = ({ classes }) => {
  return (
    <Dialog
      classes={{
        paper: classes.paper,
      }}
      open
      onClose={closeModal}
    >
      <div className={classes.buttonRow}>
        <IconButtonLabelBelow
          label="Call"
          icon={<Call />}
          onClick={changeModals(modalConsts.logCall)}
          className={classes.icon}
          IconClass={classes.icon}
        />
        <IconButtonLabelBelow
          label="Task"
          icon={<Assignment />}
          onClick={changeModals(modalConsts.simpleActionItemModal)}
          className={classes.icon}
          IconClass={classes.icon}
        />
        <IconButtonLabelBelow
          label="Note"
          icon={<Note />}
          onClick={changeModals(modalConsts.advisorNote)}
          className={classes.icon}
          IconClass={classes.icon}
        />
      </div>
    </Dialog>
  );
};

TimelineNewEventDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TimelineNewEventDialog);
